/*
 * YMME fitment finder - Make / Model / Year / Engine cascading selects.
 * Data comes from window.YMME_DATA (assets/ymme-data.js).
 * Each [data-ymme] element is independent, so the section can be used more than once.
 */
(function () {
  'use strict';

  var ORDER = ['make', 'model', 'year', 'engine'];

  function rowsToObjects(data) {
    return (data && data.rows ? data.rows : []).map(function (r) {
      return { make: r[0], model: r[1], from: r[2], to: r[3], engine: r[4], tag: r[5] };
    });
  }

  /* Natural-ish sort so "F-250" lands after "F-150" and 2.0L before 10.0L. */
  function smartSort(a, b) {
    return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
  }

  function matches(row, sel) {
    if (sel.make && row.make !== sel.make) return false;
    if (sel.model && row.model !== sel.model) return false;
    if (sel.year && !(row.from <= +sel.year && +sel.year <= row.to)) return false;
    if (sel.engine && row.engine !== sel.engine) return false;
    return true;
  }

  function optionsFor(rows, field, sel) {
    var out = {};
    rows.forEach(function (row) {
      if (!matches(row, sel)) return;
      if (field === 'year') {
        for (var y = row.from; y <= row.to; y++) out[y] = true;
      } else {
        out[row[field]] = true;
      }
    });
    var list = Object.keys(out);
    return field === 'year'
      ? list.sort(function (a, b) { return b - a; })   /* newest year first */
      : list.sort(smartSort);
  }

  function YmmeFinder(root) {
    this.root = root;
    this.rows = rowsToObjects(window.YMME_DATA);
    this.collection = root.dataset.collection || 'all';
    this.storageKey = root.dataset.remember === 'true' ? 'ymme:last' : null;
    this.selects = {};
    var self = this;
    ORDER.forEach(function (f) {
      self.selects[f] = root.querySelector('[data-ymme-field="' + f + '"]');
    });
    this.button = root.querySelector('[data-ymme-submit]');
    this.resetBtn = root.querySelector('[data-ymme-reset]');
    this.message = root.querySelector('[data-ymme-message]');
    this.form = root.querySelector('form');

    if (!this.rows.length) {
      this.say('Fitment data failed to load. Check that ymme-data.js is present in the theme assets.');
      return;
    }
    this.bind();
    this.restore();
    this.refresh();
  }

  YmmeFinder.prototype.selection = function () {
    var self = this;
    var sel = {};
    ORDER.forEach(function (f) {
      sel[f] = self.selects[f] && self.selects[f].value ? self.selects[f].value : '';
    });
    return sel;
  };

  YmmeFinder.prototype.bind = function () {
    var self = this;
    ORDER.forEach(function (field, i) {
      var el = self.selects[field];
      if (!el) return;
      el.addEventListener('change', function () {
        /* clear everything downstream of the field that changed */
        ORDER.slice(i + 1).forEach(function (f) {
          if (self.selects[f]) self.selects[f].value = '';
        });
        self.refresh();
      });
    });
    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.go();
      });
    }
    if (this.resetBtn) {
      this.resetBtn.addEventListener('click', function (e) {
        e.preventDefault();
        ORDER.forEach(function (f) { if (self.selects[f]) self.selects[f].value = ''; });
        if (self.storageKey) { try { localStorage.removeItem(self.storageKey); } catch (err) {} }
        self.refresh();
      });
    }
  };

  /* Rebuild every select's options from the current upstream selection. */
  YmmeFinder.prototype.refresh = function () {
    var self = this;
    var sel = this.selection();

    ORDER.forEach(function (field, i) {
      var el = self.selects[field];
      if (!el) return;
      var upstream = {};
      ORDER.slice(0, i).forEach(function (f) { upstream[f] = sel[f]; });

      /* A field only opens up once everything before it has a value. */
      var ready = ORDER.slice(0, i).every(function (f) { return !!sel[f]; });
      var values = ready ? optionsFor(self.rows, field, upstream) : [];
      var keep = el.value;

      el.innerHTML = '';
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = el.getAttribute('data-placeholder') || 'Select';
      el.appendChild(ph);
      values.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v;
        o.textContent = v;
        el.appendChild(o);
      });

      el.value = values.indexOf(keep) > -1 ? keep : '';
      el.disabled = !ready || values.length === 0;
      var field_wrap = el.closest('.ymme__field');
      if (field_wrap) field_wrap.classList.toggle('ymme__field--disabled', el.disabled);
      sel[field] = el.value;
    });

    var complete = ORDER.every(function (f) { return !!sel[f]; });
    if (this.button) this.button.disabled = !complete;
    if (complete) this.say('');
  };

  YmmeFinder.prototype.say = function (text) {
    if (!this.message) return;
    this.message.textContent = text;
    this.message.hidden = !text;
  };

  YmmeFinder.prototype.go = function () {
    var sel = this.selection();
    var complete = ORDER.every(function (f) { return !!sel[f]; });
    if (!complete) {
      this.say(this.root.getAttribute('data-incomplete-message') || 'Please choose a make, model, year and engine.');
      return;
    }
    var hits = {};
    this.rows.forEach(function (row) { if (matches(row, sel)) hits[row.tag] = true; });
    var tags = Object.keys(hits);
    if (!tags.length) {
      this.say(this.root.getAttribute('data-empty-message') || 'No application available for that combination.');
      return;
    }
    this.remember(sel);
    /* The data has exactly one tag per Make/Model/Year/Engine leaf; if that ever
       changes, land on the first match rather than failing. */
    window.location.href =
      '/collections/' + encodeURIComponent(this.collection) + '/' + encodeURIComponent(tags[0]);
  };

  YmmeFinder.prototype.remember = function (sel) {
    if (!this.storageKey) return;
    try { localStorage.setItem(this.storageKey, JSON.stringify(sel)); } catch (e) {}
  };

  /* Prefill from ?make=&model=&year=&engine= first, then from localStorage. */
  YmmeFinder.prototype.restore = function () {
    var params = new URLSearchParams(window.location.search);
    var saved = {};
    if (this.storageKey) {
      try { saved = JSON.parse(localStorage.getItem(this.storageKey)) || {}; } catch (e) {}
    }
    var self = this;
    ORDER.forEach(function (f, i) {
      var v = params.get(f) || saved[f] || '';
      if (!v || !self.selects[f]) return;
      var upstream = {};
      var ok = true;
      ORDER.slice(0, i).forEach(function (p) {
        var pv = self.selects[p] ? self.selects[p].value : '';
        upstream[p] = pv;
        if (!pv) ok = false;
      });
      if (!ok) return;
      if (optionsFor(self.rows, f, upstream).indexOf(String(v)) === -1) return;
      var o = document.createElement('option');
      o.value = v;
      o.textContent = v;
      self.selects[f].appendChild(o);
      self.selects[f].value = v;
    });
  };

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[data-ymme]');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.ymmeReady) return;
      el.ymmeReady = true;
      new YmmeFinder(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  /* theme editor: re-init when the section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
